/* global common */
import {
  libInit,
  prefetchImageFromSource,
  sendGoogleEvent,
  isObjectFitSupported,
  byWindowAction, sendAmplitudeEvent,
} from '@html/_common/utils';

export default function HeroImageGalleryGrid(
  tdpEventCategory,
  imageGalleryLightboxManager,
  scrollTo,
  initialClickedImageCount,
) {
  const $mainHeroImageWrapper = $('.js-ao-tour-hero-image-wrapper');
  const $gridGalleryImageItem = $('.js-ao-tour-hero-image-gallery-item');
  const $gridGalleryReviewItem = $('.js-ao-tour-hero-image-gallery-review');
  const $gridGalleryVideoOverlay = $('.js-ao-tour-hero-image-gallery-video-overlay');

  let imageUrls = null;
  let currentImageIndex = 0;
  let isOpeningPopup = false;
  let popupInitialized = false;

  this.common = typeof sendGoogleEvent !== 'undefined' ? {
    prefetchImageFromSource,
    sendGoogleEvent,
    isObjectFitSupported,
    byWindowAction,
    lib: { init: libInit },
  } : common;

  this.initiate = (newImageUrls) => {
    const preparedImageUrls = this.setupImageUrls(newImageUrls);

    this.initiateGalleryPopup(preparedImageUrls);
    this.setupClickEvents();
    this.setupVideoIframe();
  };

  this.openFirstClickedImage = () => {
    if (initialClickedImageCount !== null && initialClickedImageCount > -1) {
      currentImageIndex = initialClickedImageCount;
      $('.js-ao-tour-modal-trigger').click();
    }
  };

  this.openImageOnIndex = (index) => {
    const waitForPopupInitialization = () => {
      if (popupInitialized && !isOpeningPopup) {
        currentImageIndex = index;
        $('.js-ao-tour-modal-trigger').click();
      } else {
        // Wait 50ms and try again
        setTimeout(waitForPopupInitialization, 50);
      }
    };

    waitForPopupInitialization();
  };

  this.initiateGalleryPopup = (imageSources) => {
    imageGalleryLightboxManager.createNewImageGallery(imageSources, {
      openElementSelector: '.js-ao-tour-modal-trigger',
      startingIndex: () => this.getCurrentIndex(),
      lowerResolutionImageSize: '232x150',
      higherResolutionImageSize: '1500x800',
      openCallback: () => {
        isOpeningPopup = true;
        $('.js-ao-tour-hero-image-gallery-wrapper-overlay')?.addClass('hid');
      },
      closeCallback: () => {
        isOpeningPopup = false;
      },
      callBackAfterCreation: () => {
        this.openFirstClickedImage();
        popupInitialized = true;
      },
      googleEvents: {
        category: tdpEventCategory,
        eventGalleryName: 'Hero',
        actionVariations: [
          {
            className: 'js-ao-tour-hero-image-wrapper',
            action: 'With image click',
          },
        ],
      },
    });
  };

  this.setupImageUrls = (additionalImageUrls) => {
    const startingImageUrl = $mainHeroImageWrapper.data('starting-image-url');
    const imageAlreadyExists = startingImageUrl.split('/').pop() === additionalImageUrls[0].split('/').pop();
    imageUrls = additionalImageUrls[0].includes('youtube') || imageAlreadyExists ? additionalImageUrls : [startingImageUrl, ...additionalImageUrls];
    return imageUrls;
  };

  this.setupClickEvents = () => {
    $gridGalleryImageItem.on('click', (event) => {
      $('.js-ao-tour-hero-image-gallery-wrapper-overlay')?.removeClass('hid');
      event.preventDefault();
      event.stopPropagation();
      const $clickedElement = $(event.currentTarget);
      const waitForPopupInitialization = () => {
        if (popupInitialized && !isOpeningPopup) {
          currentImageIndex = $clickedElement?.data('image-count');
          setTimeout(() => {
            $('.js-ao-tour-modal-trigger').click();
          }, 500);
          // $('.js-ao-tour-modal-trigger').click();

          sendAmplitudeEvent({
            ampEventName: 'tdp_hero_gallery_clicked',
            tdp_hero_gallery: 'Multi-media',
            tdp_hero_gallery_type_clicked: 'Operator Photo',
            tdp_hero_gallery_position: currentImageIndex + 1,
          });
        } else {
          // Wait 50ms and try again
          setTimeout(waitForPopupInitialization, 50);
        }
      };

      waitForPopupInitialization();
    });

    $gridGalleryReviewItem.on('click', () => {
      scrollTo('reviews', '', '');

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_clicked',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: 'Customer Review',
      });
    });
  };

  this.setupVideoClickEvents = () => {
    // Track video playing state
    let isVideoPlaying = true;

    // Handle left-clicks on overlay to toggle video play/pause
    $gridGalleryVideoOverlay.on('click', (event) => {
      if (isOpeningPopup) {
        isVideoPlaying = true;
        isOpeningPopup = false;
        const $lightboxVideoOverlay = $('.js-ao-tour-image-gallery__video-overlay');
        $lightboxVideoOverlay.removeClass('ao-tour-image-gallery__main-video-overlay--play');
        $lightboxVideoOverlay.addClass('ao-tour-image-gallery__main-video-overlay--pause');
      }

      const clickOffsetY = event.offsetY;
      const overlayHeight = $gridGalleryVideoOverlay.height();
      const overlayHeightThird = overlayHeight / 3;
      const isClickInTheMiddle = clickOffsetY > overlayHeightThird && clickOffsetY < overlayHeightThird * 2;

      if (!isClickInTheMiddle) {
        event.preventDefault();
        event.stopPropagation();

        const $clickedElement = $(event.currentTarget).parent().find($('.js-ao-tour-hero-image-gallery-video-iframe'));
        currentImageIndex = $clickedElement.data('image-count');
        return $('.js-ao-tour-modal-trigger').click();
      }

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_video',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: isVideoPlaying ? 'Pause' : 'Play',
      });

      const $clickedOverlay = $(event.currentTarget);
      const iframe = $clickedOverlay.siblings('.js-ao-tour-hero-image-gallery-video-iframe')[0];
      const videoFunc = isVideoPlaying ? 'pauseVideo' : 'playVideo';
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(`{"event":"command","func":"${videoFunc}","args":""}`, '*');
        $(event.currentTarget)
          .addClass(isVideoPlaying ? 'ao-tour-hero-image-gallery-video-overlay--play' : 'ao-tour-hero-image-gallery-video-overlay--pause')
          .removeClass(isVideoPlaying ? 'ao-tour-hero-image-gallery-video-overlay--pause' : 'ao-tour-hero-image-gallery-video-overlay--play');
        isVideoPlaying = !isVideoPlaying;
        return true;
      }

      return false;
    });
  };

  this.setupVideoIframe = () => {
    const $videoElement = $('.js-ao-tour-hero-image-gallery-video');

    if ($videoElement.length > 0) {
      const embedId = $videoElement.attr('data-embed');
      const counter = $videoElement.attr('data-counter');
      if (embedId) {
        const iframeHtml = `<iframe
            class='ao-tour-hero-image-gallery-video-iframe js-ao-tour-hero-image-gallery-video-iframe'
            src="https://www.youtube.com/embed/${embedId}?autoplay=1&enablejsapi=1&mute=1&controls=0&loop=1&playlist=${embedId}"
            title="YouTube video player"
            frameborder="0"
            allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            data-image-count="${counter}"
          ></iframe>`;

        $videoElement.append(iframeHtml);

        // Remove play overlay class
        $('.js-ao-tour-hero-image-gallery-video-overlay').removeClass('ao-tour-hero-image-gallery-video-overlay--thumbnail');
        $videoElement.find('picture').remove();
        this.setupVideoClickEvents();
      }
    }
  };

  this.getCurrentIndex = () => currentImageIndex;
}
